import PAYOUT_PROFILES_API from 'api/payout/profiles/v1'
import GridSpinner from 'components/UI/GridSpinner'
import pick from 'lodash/pick'
import formStyles from 'modules/Forms/common-form.module.scss'
import PayoutProfileCreateForm from 'modules/Forms/Referral/PayoutProfileCreate'
import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import useQueryParams from 'utils/hooks/useQueryParams'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { useParams } from 'react-router'
import PageHeader from 'components/PageHeader'

const Create = () => {
  const history = useHistory()
  const { i18n } = useSelector(({ app }) => app)
  const pathGen = useGeneratePathI18n()
  const { id } = useParams()
  const { t } = useTranslation()
  const { query: { goBack } = {} } = useQueryParams()
  const [initialValues, setInitialValues] = useState()
  const profileId = useMemo(() => (id !== 'new' ? id : undefined), [id])
  const [profileTitle, setProfileTitle] = useState('')

  useEffect(() => {
    if (profileId) {
      PAYOUT_PROFILES_API.fetchById({ profileId })
        .then(({ response, error }) => {
          if (error) {
            throw error
          }

          setInitialValues(pick(response.data, ['id', 'type', 'wallet', 'currency', 'name']))
          setProfileTitle(response.data.name)
        })
        .catch((error) => {
          history.push(goBack ? goBack : pathGen(ROUTES.REFERRAL_PAYOUT_PROFILES))
          console.logXHR(error)
        })
    }
  }, [])

  return (
    <div className={formStyles['formContainer']}>
      <div className={formStyles['formContainer__inner']}>
        <PageHeader className={'margin-bottom-32'}>
          {t('referral::payout_profiles_new.header', {
            context: profileId ? 'edit' : 'new',
            title: profileTitle,
          })}
        </PageHeader>
        {profileId && !initialValues ? (
          <GridSpinner />
        ) : (
          <PayoutProfileCreateForm
            profileId={profileId}
            initialValues={initialValues}
            onClose={() => {
              history.push(
                goBack
                  ? goBack
                  : pathGen(ROUTES.REFERRAL_PAYOUT_PROFILES, {
                      i18n,
                    }),
              )
            }}
          />
        )}
      </div>
    </div>
  )
}

export default Create
